import { BOSH_USLUB } from "./scale";

export interface DayStripCell {
	color: string;
	/** Holat SO'Z bilan — `title` va `aria-label` ga tushadi. */
	tooltip: string;
}

export interface DayStripProps {
	cells: DayStripCell[];
	/** Katak balandligi, px. */
	height?: number;
	/** Ro'yxat nomi (reja imzosidan kengaytirilgan). */
	ariaLabel?: string;
	/** Katak yo'q bo'lganda matn (reja imzosidan kengaytirilgan). */
	empty?: string;
}

/**
 * Umumiy kunlik lenta — har kun bitta rangli katak, kenglik bo'yicha
 * teng taqsimlangan.
 *
 * ⚠️ **`modules/employees/components/DayStrip.tsx` bu yerga
 * KO'CHIRILMAGAN** — u boshqa narsa: `DayCell` tipi, `employees`
 * tarjimasi, kechikish/erta ketish chiziqchalari va antd `Tooltip`.
 * Bu primitiv esa rang + matnni tashqaridan oladi va `title` bilan
 * ishlaydi (ko'p katakda `Tooltip` og'ir — `CompactDayStrip.tsx`).
 *
 * ⚠️ `<ul>`/`<li>` — `role="list"` bo'lgan `<div>` ni Biome ning
 * `a11y/useSemanticElements` qoidasi rad etadi.
 *
 * ⚠️ `data-day-cell` — TEST KONTRAKTI.
 */
export function DayStrip({ cells, height = 28, ariaLabel, empty }: DayStripProps) {
	if (cells.length === 0) {
		return (
			<div className="py-4 text-center text-xs" style={BOSH_USLUB}>
				{empty}
			</div>
		);
	}

	return (
		<ul aria-label={ariaLabel} className="m-0 flex list-none gap-px p-0">
			{cells.map((katak, i) => (
				<li
					// biome-ignore lint/suspicious/noArrayIndexKey: lenta tartibi — kun indeksi katakning o'zligi
					key={i}
					data-day-cell
					title={katak.tooltip}
					aria-label={katak.tooltip}
					className="min-w-0 flex-1 rounded-sm"
					style={{ height: `${height}px`, backgroundColor: katak.color }}
				/>
			))}
		</ul>
	);
}
